import { render, staticRenderFns } from "./AgentCreate.vue?vue&type=template&id=06aa0151&"
import script from "./AgentCreate.vue?vue&type=script&lang=ts&"
export * from "./AgentCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports